import React from "react";
import { Route } from "react-router-dom";
import { AuthConsumer } from "../Authentication/AuthProvider";
import UserManager from "../helpers/userManager";
import CustomSpinner from "./CustomSpinner";
// import roles from "../helpers/role";
// import AuthService from "../Authentication/AuthService";
export const PrivateRoute = ({ component, ...rest }) => {
  const renderFn = (Component) => (props) =>
    (
      <AuthConsumer>
        {({ isAuthenticated, signinRedirect }) => {
        /*   if (localStorage.getItem("version") === null) {
            localStorage.setItem("version", false);
          } */
          if (
            !!Component &&
            isAuthenticated()/*  &&
            localStorage.getItem("version") === "0.01" */
          ) {
            return <Component {...props} />;
          } else {
            localStorage.clear();
            if( window.location.href.indexOf("/Home/BudgetListView") !==-1 ){
              return <Component {...props} />;
            }else{
              signinRedirect();
            }
            return <CustomSpinner />;
          }
        }}
      </AuthConsumer>
    );
  return <Route {...rest} render={renderFn(component)} />;
};

export default PrivateRoute;
